<span class="close-icon" style="cursor: pointer" (click)="onCloseModal()">
    <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M3.26562 32.7093L0.859375 30.2155L14.0937 16.4999L0.859375 2.78428L3.26562 0.290527L16.5 14.0062L29.7344 0.290527L32.1406 2.78428L18.9062 16.4999L32.1406 30.2155L29.7344 32.7093L16.5 18.9937L3.26562 32.7093Z"
            fill="#ACACAC" />
    </svg>
</span>
<div id="participants" class="participants-cotainer model-cotainer ">
    <h2 mat-dialog-title class="font-bold title">{{'StartSimulation.Name' | translate }}</h2>
    <div class="par-simulation-name position-relative">
        <div class="left d-flex float-left" style="padding: 4px">
            <svg width="35" height="33" viewBox="0 0 35 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.4606 12.6989H27.7502V10.0509H12.4606V12.6989ZM12.4606 19.5322H27.7502V16.8843H12.4606V19.5322ZM8.95856 12.8697C9.38564 12.8697 9.74155 12.7273 10.0263 12.4426C10.311 12.1579 10.4534 11.802 10.4534 11.3749C10.4534 10.9478 10.311 10.5919 10.0263 10.3072C9.74155 10.0225 9.38564 9.88011 8.95856 9.88011C8.53148 9.88011 8.17558 10.0225 7.89085 10.3072C7.60613 10.5919 7.46377 10.9478 7.46377 11.3749C7.46377 11.802 7.60613 12.1579 7.89085 12.4426C8.17558 12.7273 8.53148 12.8697 8.95856 12.8697ZM8.95856 19.703C9.38564 19.703 9.74155 19.5607 10.0263 19.2759C10.311 18.9912 10.4534 18.6353 10.4534 18.2082C10.4534 17.7812 10.311 17.4252 10.0263 17.1405C9.74155 16.8558 9.38564 16.7134 8.95856 16.7134C8.53148 16.7134 8.17558 16.8558 7.89085 17.1405C7.60613 17.4252 7.46377 17.7812 7.46377 18.2082C7.46377 18.6353 7.60613 18.9912 7.89085 19.2759C8.17558 19.5607 8.53148 19.703 8.95856 19.703ZM10.9659 32.2593V28.7145H3.06481C2.29606 28.7145 1.61985 28.4226 1.03617 27.839C0.452485 27.2553 0.160645 26.5791 0.160645 25.8103V3.77282C0.160645 2.9756 0.452485 2.29226 1.03617 1.72282C1.61985 1.15337 2.29606 0.868652 3.06481 0.868652H31.9356C32.7329 0.868652 33.4162 1.15337 33.9856 1.72282C34.5551 2.29226 34.8398 2.9756 34.8398 3.77282V25.8103C34.8398 26.5791 34.5551 27.2553 33.9856 27.839C33.4162 28.4226 32.7329 28.7145 31.9356 28.7145H24.0346V32.2593H10.9659ZM3.06481 25.8103H31.9356V3.77282H3.06481V25.8103ZM3.06481 25.8103V3.77282V25.8103Z"
                    fill="#17B978" />
            </svg>
        </div>
        <div class="right d-inline-block p-l-12">
            <div class="name">{{'SimulationName' | translate }}</div>
            <div class="pmt-simulation font-bold"> {{ createOrUpdateModel.detailsRequest.name }}</div>
            <div class="link simulation-elipses">{{ createOrUpdateModel.settingsRequest.link }} <span
                    class="icon-copy position-absolute" (click)="copySimulationLink()" matTooltip="Copied!"
                    [matTooltipDisabled]="true" #matTooltipCopied="matTooltip" [matTooltipShowDelay]="0"
                    [matTooltipHideDelay]="1000">
                    <svg width="19" height="22" viewBox="0 0 19 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M2.45 21.2251C1.98333 21.2251 1.58333 21.0584 1.25 20.7251C0.916667 20.3918 0.75 19.9918 0.75 19.5251V4.5001H2.45V19.5251H14.25V21.2251H2.45ZM5.65 18.0251C5.2 18.0251 4.80417 17.8543 4.4625 17.5126C4.12083 17.1709 3.95 16.7751 3.95 16.3251V2.4251C3.95 1.95843 4.12083 1.55843 4.4625 1.2251C4.80417 0.891764 5.2 0.725098 5.65 0.725098H16.55C17.0167 0.725098 17.4167 0.891764 17.75 1.2251C18.0833 1.55843 18.25 1.95843 18.25 2.4251V16.3251C18.25 16.7751 18.0833 17.1709 17.75 17.5126C17.4167 17.8543 17.0167 18.0251 16.55 18.0251H5.65ZM5.65 16.3251H16.55V2.4251H5.65V16.3251ZM5.65 16.3251V2.4251V16.3251Z"
                            fill="#17B978" />
                    </svg>
                </span></div>

        </div>
        <div class="simulation-code position-absolute">
            {{ createOrUpdateModel.settingsRequest.loginCode }}
        </div>
    </div>
    <div class="participant-waiting">
        <div class="header-box font-bold">
            {{'StartSimulation.ParticipentThatAreWaiting' | translate: { number:
            createOrUpdateModel.settingsRequest.invitePeople?.length } }}
        </div>
        <div class="list-user">
            <div class="lst-user-item d-flex align-items-center"
                *ngFor="let user of createOrUpdateModel.settingsRequest.invitePeople; let i = index">
                <span class="avata" *ngIf="!user.avatar">
                    <img class="avata-image" src="../../../../../assets/images/avata-default.png" alt="avata-default" />
                </span>
                <span class="avata" *ngIf="user.avatar">
                    <img class="avata-image" src="{{ user.avatar }}" alt="avata-default" />
                </span>
                <span class="name">{{ user.name }}</span>
            </div>
        </div>
    </div>
    <div class="allow-start-video">
        <div class="form-field w-100" appearance="fill">
            <mat-checkbox [checked]="false"
                [(ngModel)]="createOrUpdateModel.settingsRequest.allowJoinAfterSimulationStarts"
                name="aceptJoinAfterStart">
                {{'StartSimulation.AllowJoinAfterStarts' | translate }}
            </mat-checkbox>
        </div>
        <!-- <div class="form-field w-100" appearance="fill">
            <mat-checkbox [checked]="false" [(ngModel)]="this.createOrUpdateModel.settingsRequest.startVideoRecording"
                name="aceptRecording">
                {{'StartSimulation.StartVideoRecording' | translate }}
            </mat-checkbox>
        </div> -->
    </div>
    <div class="algin-center w-100 box-start-now">
        <button mat-button class="font-bold btn-common-style btn-start-now"
            (click)="onStartSimulationNow()">{{'StartSimulation.StartSimulationNow' | translate : { appName :
            'Simulation Now' } }}</button>
    </div>
</div>
